// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-block{background:rgba(182,218,225,.3);height:55vh;position:absolute;width:55vh;z-index:-1}.bg-block-1{left:8vh;top:17vh}.bg-block-1,.bg-block-2{transform:rotate(-17deg)}.bg-block-2{bottom:-20vh;right:-10vh}::-moz-selection{background:#00848d;color:#fff}::selection{background:#00848d;color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
